import React, { Component } from 'react';
import _ from 'lodash';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  WithStyles,
  withStyles,
  TableHead,
  TextField,
  MenuItem,
  Grid,
  Typography,
  Link,
  Button,
  Paper,
  ClickAwayListener,
} from '@material-ui/core';
import { MyPATTextArea, MyPATTextField, MyPATDialog, MyPATMultiSearch } from '../../common';
import createStyles from '@material-ui/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MyPATCalendar from '../../common/MyPATCalendar';
import { onlyAllowNumbers } from '../../../utils';
import { ContentSubType } from '../../test-template/types/ContentSubTypeBody';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import {
  TestSeriesCoursePlan as testSeriesCoursePlan,
  TestDetail,
  TestSeriesCoursePlan,
} from '../types/interfaces/CourseBasicDetails';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { format } from 'date-fns';
import classNames from 'classnames';
import { TestDetails } from '../../content-request/containers/CardData/CardDataTabs';
import { AddTestDialog } from './coursePlan/addTestDialog';
import AddTestPopUp from './coursePlan/addTestDialog/AddTestPopUp';
import { getDeafultTestDetail } from '../helpers/helpers';
import ContentTypeToggleDialog from './PopUp/ContentTypeToggleDialog';
import ToggleInput from '../../common/ToggleInput';
import { HIDE_TEST_POPUP_INFO } from '../Constants/constants';

const styles = (theme: Theme) =>
  createStyles({
    ActionCTA: {
      marginLeft: 18,
      cursor: 'pointer',
      color: '#1d7dea',
      textTransform: 'uppercase',
      fontWeight: 700,
    },
    testCard: {
      padding: 15,
      borderTop: '1px solid #E6E6E6',
      borderBottom: '1px solid #E6E6E6',
      cursor: 'pointer',
      position: 'relative',
    },
    AddTest: {
      position: 'absolute',
      left: 0,
      bottom: '-10px',
      zIndex: 999,
      width: '100%',
      padding: 0,
      '& button': {
        background: 'transparent',
        '&:hover': {
          background: 'transparent',
        },
      },
      '& img': {
        width: '100%',
        display: 'block',
      },
    },
    testTitle: {
      fontSize: 20,
      lineHeight: '27px',
      color: '#333',
      maxWidth: 900,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      '&> img': {
        width: 20,
      },
    },
    dateAndTime: {
      fontSize: 16,
      fontWeight: 400,
      color: '#666',
      lineHeight: '18px',
      marginTop: 10,
    },
    marginL10: {
      marginLeft: 10,
    },
    saveDialogContainer:{
         '&>div':{
          //  marginTop:'16px'
         }
    },
    delButton:{
      marginLeft: 30,
      padding: "0px 32px",
      height: 40,
      lineHeight: '40px',
    },
    link:{
      fontWeight: 'bold',
      '&:hover':{
        cursor: 'pointer',
      }
    },
   halfOpacity:{
     opacity:0.5
   }
  });
interface Props {
  transferToParent: (coursePlan: TestSeriesCoursePlan) => void;
  testDetail: TestDetail;
  coursePlan: TestSeriesCoursePlan;
  index: number;
  classes: any;
  handleDeleteCard: Function;
  courseDetails: any[];
  isPreviewScreen: boolean;
  showTestVisibility?: boolean;
  handleTestVisibilityToggle?: Function;
}

interface State {
  showAddTestPopUp: boolean;
  showEditTestPopUp: boolean;
  showAddTestBttn: boolean;
  deleteConfirmPopUp:boolean;
}

class TestDetailCard extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showAddTestPopUp: false,
      showEditTestPopUp: false,
      showAddTestBttn: false,
      deleteConfirmPopUp:false
    };
  }

  componentDidMount = () => {};
  componentDidUpdate(prevProps: Props, prevState: State) {}

  handleAddTest = (testDetail: TestDetail) => {
    const { index } = this.props;
    const newCoursePlan = { ...this.props.coursePlan };
    let newTestSeries = [...newCoursePlan.testSeries];
   
    newTestSeries[index] = testDetail;
    newCoursePlan.testSeries=newTestSeries;

    this.props.transferToParent(newCoursePlan);
    this.setState({ showEditTestPopUp: false, showAddTestPopUp: false});
  };
  handlePlusIcon = () => {
    const{index,coursePlan,courseDetails}=this.props;
    const newCoursePlan = { ...coursePlan };
    let newTestSeries = [...newCoursePlan.testSeries];
    
    const firstCourseId = _.get(courseDetails,"[0].courseId", "");

    let lastIndx=newTestSeries.length;
    
    const testDetail: TestDetail = getDeafultTestDetail();
    testDetail.name = `Test-${lastIndx+ 1}`;
    // testDetail.startDate=coursePlan.startDate;
     testDetail.courseId=firstCourseId;

    newTestSeries.splice(index + 1, 0, testDetail);
    
    newCoursePlan.testSeries=newTestSeries;
    newCoursePlan.totalTests=newTestSeries.length;
    
    this.props.transferToParent(newCoursePlan);
  };
  handleEditBttn = () => {
    const{testDetail}=this.props;
    
    if(testDetail.maxAttempts){
      this.setState({ showEditTestPopUp:true });
    }
    else
       this.setState({showAddTestPopUp:true});
  };
  handleHover = () => {
    this.setState({ showAddTestBttn: !this.state.showAddTestBttn });
  };
  redirectUrl = (id: any, e: any) => {
    console.log('url;;-', id);
    e.stopPropagation();
    let url = '/content/preview/' + id + 'testpapers';
    window.open(url, '_blank');
  };
  handleDeleteBttn=()=>{
    this.setState({deleteConfirmPopUp:!this.state.deleteConfirmPopUp});
  }
  proceed=()=>{
    const{handleDeleteCard,index}=this.props;
    handleDeleteCard(index);
    this.handleDeleteBttn();
  }
  closeHovering = () => {
    this.setState({ showAddTestBttn: false});
  };

  checkMapTestIdExist=(testId:string)=>{
    const{coursePlan}=this.props;
    const{testSeries}=coursePlan;
    let exist=false;
    testSeries.forEach((test)=>{
      console.log({test});
      if(test.testId&&test.testId===testId)
         exist=true;
    });
   return exist; 
  }
  closePopUp=()=>{
    this.setState({showAddTestPopUp:false,showEditTestPopUp:false});
  }

  changeTestVisibilityToggle = (element: any, toggleValue: any) => {
    const { handleTestVisibilityToggle } = this.props;
    handleTestVisibilityToggle && handleTestVisibilityToggle(element, toggleValue);
  };

  render() {
    const { testDetail, index, classes, handleDeleteCard, courseDetails, isPreviewScreen, showTestVisibility } = { ...this.props };
    const { showAddTestPopUp, showEditTestPopUp, showAddTestBttn,deleteConfirmPopUp } = this.state;
    const { name, startDate, endDate, testId } = testDetail;
    
    const zero24='000000000000000000000000';
    return (
      <>
      <Grid>
       <ClickAwayListener onClickAway={() =>setTimeout(this.closeHovering)}>
        <Grid container onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
          <Grid item xs={12}>
            <Grid container justify='space-between' alignItems='center' className={classes.testCard}>
              <Grid item>
                <Grid container alignItems='center' justify='flex-start'>
                  <span>
                    <img className={`${testId===zero24?classes.halfOpacity:""}`} src='/assets/svg/goalGreyNav.svg' />
                  </span>
                  <Typography className={classes.marginL10}>
                    <div className={classes.testTitle}>{testDetail.displayName || name}</div>
                    
                      <div className={classes.dateAndTime}>
                       {!_.isEmpty(startDate) && <span>{format(new Date(testDetail.scheduleDate || startDate), "dd-MMM-yyyy hh:mm a")}</span>}
                       {!_.isEmpty(endDate) && <>
                         <span>{' to '}</span>
                          <span>{format(new Date(testDetail.scheduleEndDate || endDate), "dd-MMM-yyyy hh:mm a")}</span>
                        </>
                        }
                      </div>
                  </Typography>
                </Grid>
              </Grid>
              <div style={{
                    display: "flex",
                    alignItems: "center",
                  }}>
              {showTestVisibility && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "15px",
                  }}
                >
                  Hide Test <CustomInfoIcon
                    infoDialogContentType="Hide Test"
                    isCenterArrow={true}
                    isRightArrow={false}
                    isInfoIcon={true}
                    knowMoreAbout={false}
                    dialogTitle="Hide Test"
                    dialogPara={HIDE_TEST_POPUP_INFO}
                    details="Click to know more"
                    toolTipDirection="top"
                  />
                  <ToggleInput
                    isChecked={testDetail.isHidden}
                    disabled={isPreviewScreen}
                    handleToggle={(event: any) => this.changeTestVisibilityToggle(testDetail,event)}
                  />
                </div>
              )}
              {isPreviewScreen ? (
                <Grid item>
                  {testId !== zero24 && (
                    <span
                      className={classes.ActionCTA}
                      onClick={(e) => {
                        this.redirectUrl(testId, e);
                      }}
                    >
                      View Test
                    </span>
                  )}
                </Grid>
              ) : (
                <Grid item>
                  <span className={classes.ActionCTA} onClick={this.handleEditBttn}>
                    <img src='/assets/svg/editOutline.svg' />
                  </span>
                  <span
                    className={classes.ActionCTA}
                    onClick={this.handleDeleteBttn}
                  >
                    <img src='/assets/svg/delete.svg' />
                  </span>
                </Grid>
              )}
              </div>
              <Grid className={classes.AddTest}>
                {showAddTestBttn && !isPreviewScreen && (
                  <Button onClick={this.handlePlusIcon} className={classes.AddTest}>
                    {/* Add Test */}
                    <img src='/assets/svg/AddLine.svg' />
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        </ClickAwayListener>
        </Grid>
        {showEditTestPopUp && (
          <AddTestPopUp
            open={showEditTestPopUp}
            onClose={this.closePopUp}
            isEditMode={true}
            testDetail={testDetail}
            courseDetails={courseDetails}
            onDone={this.handleAddTest}
            key={index}
            coursePlan={this.props.coursePlan}
            checkMapTestIdExist={this.checkMapTestIdExist}
          />
        )}
         {showAddTestPopUp && (
          <AddTestPopUp
            open={showAddTestPopUp}
            onClose={this.closePopUp}
            courseDetails={courseDetails}
            testDetail={testDetail}
            onDone={this.handleAddTest}
            key={index}
            coursePlan={this.props.coursePlan}
            checkMapTestIdExist={this.checkMapTestIdExist}
          />
        )}
          { deleteConfirmPopUp && 
             <MyPATDialog
             dialogOpen={deleteConfirmPopUp}
             dialogHeading=" "
             isAlignCenter={true}
             dialogHasActions={true}
             customButtonVariant="withoutBorderCloseIcon"
             onDialogClose={this.handleDeleteBttn}
             isCustomBackground={false}
             otherDialogProps={{
                 fullWidth: false,
                 maxWidth: false,
             }}
         >
             <Grid
                 container
                 direction="column"
                 justify="center"
                 alignItems="center"
                 className={classes.saveDialogContainer}
                //  alignContent="space-between
                style={{marginTop: '-20px'}}
             > 
                 <Grid item>
                       <img src='/assets/svg/delete-icon.svg' style={{height: '64px'}}/>
                 </Grid>
                 <Grid item className="paraDetails" >
                     <Typography align="center" style={{fontSize: '1.6rem', fontWeight: 'bold', margin: '10px 0'}}>
                      Delete Test
                     </Typography>
                 </Grid>
                 <Grid item className="paraDetails">
                     <Typography align="center" style={{fontSize: '1rem', color: '#666',margin: '5px 0 25px 0'}}>
                     Do you really want to delete this test from the course?
                     </Typography>
                 </Grid>
                 <Grid item xs={12}>
                     <Grid container alignItems="center" style={{marginBottom: '20px'}}>
                     <Link className={classes.link} color="primary"
                             onClick={() => { this.proceed(); this.handleDeleteBttn() }}>
                             Yes
                         </Link>
                         &nbsp;&nbsp;
                         <Button
                             variant="contained"
                             color="primary"
                             onClick={this.handleDeleteBttn}
                             className={classes.delButton}
                         >
                             No
                         </Button>
                     </Grid>
                 </Grid>
             </Grid>
         </MyPATDialog>
 
          }
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(TestDetailCard);
